import PropTypes from 'prop-types';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

// import { PageLoader } from '@repo/design-system/components/ui';
import Header from '../header/Header';
import Sidebar from '../sidebar/Sidebar';

import './MainLayout.scss';

const MainLayout = ({ componentRoutes, sidebarMenuConfig,
  isVisibleHeaderLogo
}) => {

  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const [flyout, setFlyout] = useState(null);

  const toggleMobileSidebar = () => {
    setIsMobileOpen(prev => !prev);
  };

  const toggleCollapse = () => {
    setIsCollapsed((prev) => {
      if (!prev) { setOpenMenu(null); setFlyout(null); }
      return !prev;
    });
  };


  return (
    <>
      <div className="admin-layout">
        {isVisibleHeaderLogo ? null : (
          <Sidebar componentRoutes={componentRoutes} isMobileOpen={isMobileOpen}
            setIsMobileOpen={setIsMobileOpen} menuConfig={sidebarMenuConfig}
            isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed}
            setOpenMenu={setOpenMenu} openMenu={openMenu}
            flyout={flyout} setFlyout={setFlyout} />
        )}
        <div className="main-content">
          <Header toggleMobileSidebar={toggleMobileSidebar} isVisibleHeaderLogo={isVisibleHeaderLogo}
            toggleCollapse={toggleCollapse} isCollapsed={isCollapsed} />
          <main className="content-area">
            {/* <Suspense fallback={<PageLoader />}> */}
            <Outlet />
            {/* </Suspense> */}
          </main>
        </div>
      </div>
    </>
  );
};

MainLayout.propTypes = {
  componentRoutes: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      securityKey: PropTypes.string,
      children: PropTypes.arrayOf(
        PropTypes.shape({
          path: PropTypes.string.isRequired,
          securityKey: PropTypes.string,
        })
      ),
    })
  ).isRequired,
};

export default MainLayout;
